import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import ProcessingSpinner from '../ProcessingSpinner';

const AdminEditButtons = ({
  saving,
  hideDelete,
  deleteText,
  handleSave,
  handleSaveAndInvite,
  handleDelete,
  unsaved,
}) => {
  const intl = useIntl();

  return (
    <div className="tab-footer justify-sb settings-save-wrapper">
      <div className="buttons-group">
        {!hideDelete && (
          <Button
            color="link"
            disabled={saving}
            onClick={handleDelete}
          >
            <i className="far fa-times" />
            {deleteText || intl.formatMessage({ defaultMessage: 'Delete' })}
          </Button>
        )}
      </div>
      <div className="buttons-group">
        {unsaved && (
          <p>
            {intl.formatMessage({ defaultMessage: 'You have some unsaved settings' })}
          </p>
        )}
        {(handleSaveAndInvite && !saving) && (
          <Fragment>
            <Button
              color="primary"
              disabled={saving}
              onClick={handleSaveAndInvite}
            >
              {intl.formatMessage({ defaultMessage: 'Save & send welcome email' })}
            </Button>
            {' '}
          </Fragment>
        )}
        <Button
          color="primary"
          disabled={saving}
          onClick={handleSave}
        >
          <ProcessingSpinner show={saving} />
          {intl.formatMessage({ defaultMessage: 'Save' })}
        </Button>
      </div>
    </div>
  );
};

AdminEditButtons.propTypes = {
  saving: PropTypes.bool.isRequired,
  hideDelete: PropTypes.bool,
  deleteText: PropTypes.string,
  handleSave: PropTypes.func.isRequired,
  handleSaveAndInvite: PropTypes.func,
  handleDelete: PropTypes.func,
  unsaved: PropTypes.bool,
};

AdminEditButtons.defaultProps = {
  hideDelete: false,
  deleteText: '',
  handleSaveAndInvite: null,
  handleDelete: () => {},
  unsaved: false,
};

export default AdminEditButtons;
